export const Actions = {
  LIST_APP_LOGS: "LIST_APP_LOGS",
  LIST_APP_LOGS_SUCCEEDED: "LIST_APP_LOGS_SUCCEEDED",
  CLEAR_OPERATION_RESULT: "CLEAR_OPERATION_RESULT",
  READ_APP_LOGS: "READ_APP_LOGS",
  READ_APP_LOGS_SUCCEEDED: "READ_APP_LOGS_SUCCEEDED",
  CLEAR_SELECTED_APP_LOG: "CLEAR_SELECTED_APP_LOG",
};
